import UnlockLocationContent from "../../../../../lib/html5-software-library/src/ranj/eng/content/UnlockLocationContent";
import AnimationFactory from "../../../../../lib/html5-software-library/src/ranj/ui/animation/AnimationFactory";
import AnimationOptions from "../../../../../lib/html5-software-library/src/ranj/ui/animation/AnimationOptions";
import FadeToColorOptions from "../../../../../lib/html5-software-library/src/ranj/ui/animation/transition-animations/FadeToColorOptions";
import AbstractCommand from "../../../core/application/AbstractCommand";
import SkinKeyRegistry from "../../../core/ui/SkinKeyRegistry";
import NGTScenarioPlayer from "../../../ngt/scenario/NGTScenarioPlayer";
import FeedbackEvent from "../../feedback/event/FeedbackEvent";
import KeyDecisionSummaryEvent from "../../key-decision-summary/event/KeyDecisionSummaryEvent";
import TutorialEvent from "../../tutorial/events/TutorialEvent";
import BriefingEvent from "../event/BriefingEvent";
import EpilogueEvent from "../../epilogue/event/EpilogueEvent";
import AssetLoadService from "../../../core/assetloading/AssetLoadService";
import AssetLoadServiceEvent from "../../../core/assetloading/events/AssetLoadServiceEvent";
import Config from "../../../core/config/Config";
import NGTConfigKey from "../../../ngt/base/NGTConfigKey";
import ProgressGameModel from "../../save-game/model/ProgressGameModel";

export default class CustomScreenCommand extends AbstractCommand {

    /**
     * @param {soma.EventDispatcher} dispatcher - the soma EventDispatcher
     * @param {AssetLoadService} assetLoadService 
     * @param {Config} config 
     * @param {ProgressGameModel} progressGameModel 
     */
    constructor(dispatcher, assetLoadService, config, progressGameModel) {
        super(dispatcher);
        this._assetLoadService = assetLoadService;
        this._config = config;
        this._progressGameModel = progressGameModel;
    }

    execute(evt) {
        const data = evt.params.data;

        /** @type {UnlockLocationContent} */
        this._content = data.content;
        /** @type {NGTScenarioPlayer} */
        this._contentPlayer = data.contentPlayer;

        var screen = this._content.getLocationID();

        // TODO: Make it even more generic later on

        switch (screen) {
            case CustomScreenCommand.BRIEFING_SCREEN:
                this._dispatcher.addEventListener(BriefingEvent.CLOSE_REQUEST, this._handleCloseBriefing.bind(this));

                this._briefingScreenSkin = this.openScreen(SkinKeyRegistry.BRIEFING_SCREEN_SKIN, {
                    animationType: AnimationFactory.FADE_IN,
                    animationOptions: new AnimationOptions(0, 450, createjs.Ease.sineInOut),
                }, {
                    content: this._content,
                });
                break;
            case CustomScreenCommand.TUTORIAL:
                this._dispatcher.addEventListener(TutorialEvent.CLOSE_REQUEST, this._handleCloseTutorial.bind(this));

                this._tutorialScreenSkin = this.openScreen(SkinKeyRegistry.TUTORIAL_SCREEN_SKIN, {
                    animationType: AnimationFactory.FADE_IN,
                    animationOptions: new AnimationOptions(0, 450, createjs.Ease.sineInOut),
                }, {
                    content: this._content,
                });
                break;
            case CustomScreenCommand.FEEDBACK_SCREEN:
                this._dispatcher.addEventListener(FeedbackEvent.CLOSE_SCREEN_REQUEST, this._handleCloseFeedback.bind(this));

                //Parallel with the feedback screen we start loading assets for the next chapter (in the background).
                this._loadAssetsForNextChapter();

                this._feedbackScreenSkin = this.openScreen(SkinKeyRegistry.FEEDBACK_SCREEN_SKIN, {
                    animationType: AnimationFactory.FADE_IN,
                    animationOptions: new AnimationOptions(0, 450, createjs.Ease.sineInOut),
                }, {
                    content: this._content,
                });
                break;
            case CustomScreenCommand.KEY_DECISION_SUMMARY:
                this._dispatcher.addEventListener(KeyDecisionSummaryEvent.CLOSE_REQUEST, this._handleCloseKeyDecisionSummary.bind(this));

                this._keyDecisionSummaryScreenSkin = this.openScreen(SkinKeyRegistry.KEY_DECISION_SUMMARY_SCREEN_SKIN, {
                    animationType: AnimationFactory.FADE_IN,
                    animationOptions: new AnimationOptions(0, 450, createjs.Ease.sineInOut),
                }, {
                    content: this._content,
                });
                break;
            case CustomScreenCommand.EPILOGUE:
                this._dispatcher.addEventListener(EpilogueEvent.CLOSE_REQUEST, this._handleCloseEpilogue.bind(this));

                this._epilogueScreenSkin = this.openScreen(SkinKeyRegistry.EPILOGUE_SCREEN_SKIN, {
                    animationType: AnimationFactory.FADE_IN,
                    animationOptions: new AnimationOptions(0, 450, createjs.Ease.sineInOut),
                }, {
                    content: this._content,
                });
                break;
        }
    }

    // ************ BRIEFING ********************/

    _handleCloseBriefing() {
        this._dispatcher.removeEventListener(BriefingEvent.CLOSE_REQUEST, this._handleCloseBriefing.bind(this));

        this.closeScreen(this._briefingScreenSkin, {
            animationType: AnimationFactory.FADE_OUT,
            animationOptions: new AnimationOptions(0, 450, createjs.Ease.sineInOut),
        });

        this._contentPlayer.contentCompleted(this._content);
    }


    // ************ TUTORIAL ********************/

    _handleCloseTutorial() {
        this._dispatcher.removeEventListener(TutorialEvent.CLOSE_REQUEST, this._handleCloseTutorial.bind(this));

        this.closeScreen(this._tutorialScreenSkin, {
            animationType: AnimationFactory.FADE_OUT,
            animationOptions: new AnimationOptions(0, 450, createjs.Ease.sineInOut),
        });

        this._contentPlayer.contentCompleted(this._content);
    }


    // ************ FEEDBACK SCREEN and ASSET LOADING FOR NEXT CHAPTER ********************/
    
    _handleCloseFeedback() {
        this._dispatcher.removeEventListener(FeedbackEvent.CLOSE_SCREEN_REQUEST, this._handleCloseFeedback.bind(this));

        this.closeScreen(this._feedbackScreenSkin, {
            animationType: AnimationFactory.FADE_OUT,
            animationOptions: new AnimationOptions(0, 450, createjs.Ease.sineInOut),
        });

        this._feedbackClosed = true;
        const completed = this._checkFeedbackCanBeCompleted();
        //Open loading popup?
        if (!this._assetsComplete) {
            // Open loading screen
            this._loadingPopupSkin = this.openPopup(SkinKeyRegistry.LOADING_SCREEN_SKIN, null, {
                needsOverlay: false,
                animationType: AnimationFactory.FADE_TO_COLOR_IN,
                animationOptions: new FadeToColorOptions('#000', .5, 0, 1050, createjs.Ease.sineInOut),
            });
        }
    }

    _loadAssetsForNextChapter() {
        const current = this._progressGameModel.chapter;
        if (!current) {
            console.warn("CustomScreenCommand._loadAssetsForNextChapter, no current chapter.");
            return;
        }
        const assetGroupsForChapter = this._config.getValue(NGTConfigKey.SCENARIOS)[0].chapterToAssetsMapping[current + 1];
        console.log(`Next chapter: ${current + 1}, assetGroupsForChapter: ${assetGroupsForChapter}`)
        if (assetGroupsForChapter) {
            this._assetsComplete = false;
            this._handleChapterAssetsComplete = this._handleChapterAssetsComplete.bind(this);
            this._dispatcher.addEventListener(AssetLoadServiceEvent.LOAD_COMPLETE, this._handleChapterAssetsComplete);
            this._assetLoadService.loadGroups(...assetGroupsForChapter);
        } else {            
            this._assetsComplete = true;
        }
    }

    _handleChapterAssetsComplete() {
        this._dispatcher.removeEventListener(AssetLoadServiceEvent.LOAD_COMPLETE, this._handleChapterAssetsComplete);
        // Close loading screen if any
        if (this._loadingPopupSkin) {
            this.closePopup(this._loadingPopupSkin, {
                animationType: AnimationFactory.FADE_TO_COLOR_OUT,
                animationOptions: new FadeToColorOptions('#000', .5, 0, 1050, createjs.Ease.sineInOut),
            });
            this._loadingPopupSkin = null;
        }
        this._assetsComplete = true;
        this._checkFeedbackCanBeCompleted();
    }

    _checkFeedbackCanBeCompleted() {
        if (this._feedbackClosed && this._assetsComplete) {
            this._contentPlayer.contentCompleted(this._content);
        }
    }


    // ************ KEY DECISIONS ********************/

    _handleCloseKeyDecisionSummary() {
        this._dispatcher.removeEventListener(KeyDecisionSummaryEvent.CLOSE_REQUEST, this._handleCloseFeedback.bind(this));

        this.closeScreen(this._keyDecisionSummaryScreenSkin, {
            animationType: AnimationFactory.FADE_OUT,
            animationOptions: new AnimationOptions(0, 450, createjs.Ease.sineInOut),
        });

        this._contentPlayer.contentCompleted(this._content);
    }

    _handleCloseEpilogue() {
        this._dispatcher.removeEventListener(EpilogueEvent.CLOSE_REQUEST, this._handleCloseEpilogue.bind(this));

        this.closeScreen(this._epilogueScreenSkin, {
            animationType: AnimationFactory.FADE_OUT,
            animationOptions: new AnimationOptions(0, 450, createjs.Ease.sineInOut),
        });

        this._contentPlayer.contentCompleted(this._content);
    }
}

CustomScreenCommand.BRIEFING_SCREEN = "briefing";
CustomScreenCommand.FEEDBACK_SCREEN = "feedback";
CustomScreenCommand.KEY_DECISION_SUMMARY = "kd-summary";
CustomScreenCommand.TUTORIAL = "tutorial";
CustomScreenCommand.EPILOGUE = "epilogue";